// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import QrcodeVue from 'qrcode.vue'
import VueSession from 'vue-session'
import StarRating from 'vue-star-rating'
import DatePicker from 'vuejs-datepicker'

// Vue.directive('sortable', {
//   // When the bound element is inserted into the DOM...
//   inserted: function (el, node) {
//     // Focus the element
//     return new Sortable(el, node.value)
//   }
// })

var options = {
  persist: true
}

Vue.use(VueSession, options)
Vue.prototype.$liff = window.liff
Vue.prototype.$apiUrl = 'https://asia-northeast1-foxfox-honda.cloudfunctions.net/'
Vue.prototype.$axios = axios
Vue.prototype.$QrcodeVue = QrcodeVue
Vue.prototype.$StarRating = StarRating
Vue.prototype.$DatePicker = DatePicker

Vue.prototype.$branchList = [
  {id: '10143', name: 'ปากเกร็ด'},
  {id: '10112', name: 'แจ้งวัฒนะ'},
  {id: '10115', name: 'หนองแขม'},
  {id: '10126', name: 'บางกอกน้อย'}
]
Vue.prototype.$insuranceList = [
  {
    'name': 'บริษัท กรุงเทพประกันภัย จำกัด (มหาชน)',
    'tel': '1620'
  },
  {
    'name': 'บริษัท ธนชาตประกันภัย จำกัด (มหาชน)',
    'tel': '0-2662-8999'
  },
  {
    'name': 'บริษัท คุ้มภัยโตเกียวมารีนประกันภัย (ประเทศไทย) จำกัด (มหาชน)',
    'tel': '0-2257-8000'
  },
  {
    'name': 'บริษัท สมโพธิ์ เจแปน นิปปอนโคอะ ประกันภัย',
    'tel': '0-2118-7400'
  },
  {
    'name': 'บริษัท แอกซ่าประกันภัย จำกัด (มหาชน)',
    'tel': '0-2118-8111'
  },
  {
    'name': 'บริษัท มิตซุย สุมิโตโม อินชัวร์รันซ์ จำกัด (สาขาประเทศไทย)',
    'tel': '0-2679-5000'
  },
  {
    'name': 'บริษัท แอลเอ็มจี ประกันภัย จำกัด (มหาชน)',
    'tel': '1790'
  },
  {
    'name': 'บริษัท สินทรัพย์ประกันภัย จำกัด',
    'tel': '1729'
  },
  {
    'name': 'บริษัท สินมั่งคงประกันภัย จำกัด',
    'tel': '1596'
  },
  {
    'name': 'บริษัท เอ็ม เอส ไอ จี ประกันภัย จำกัด',
    'tel': '1259'
  },
  {
    'name': 'บริษัท ทิพยประกันภัย จำกัด (มหาชน)',
    'tel': '1736'
  },
  {
    'name': 'บริษัท วิริยะประกันภัย จำกัด (มหาชน)',
    'tel': '1557'
  },
  {
    'name': 'บริษัท ประกันภัยไทยวิวัฒน์ จำกัด (มหาชน)',
    'tel': '1231'
  },
  {
    'name': 'บริษัท ซมโปะ ประกันภัย (ประเทศไทย) จำกัด (มหาชน)',
    'tel': '02-119-3000'
  },
  {
    'name': 'บริษัท อลิอันซ์ อยุธยา ประกันภัย จำกัด (มหาชน)',
    'tel': '1292'
  },
  {
    'name': 'บริษัท อาคเนย์ประกันภัย จำกัด (มหาชน)',
    'tel': '1726'
  }
]
Vue.prototype.$liffId_Main = '1653760842-qJylvK9Y'

Vue.prototype.$liffId_Service_Register = '1653760842-byJaLNBj'
Vue.prototype.$liffId_Service_Confirm = '1653760842-XxB8Azay'
Vue.prototype.$liffId_Service_ConfirmBP = '1653760842-vxdJxgNo'
Vue.prototype.$liffId_Service_QRCode = '1653760842-YmkmoeNx'
Vue.prototype.$liffId_Service_QRCodeBP = '1653760842-Bv518oQ0'
Vue.prototype.$liffId_Service_Progress = '1653760842-PvrpK9vw'
Vue.prototype.$liffId_Service_RegisterNewCar = '1653760842-OkVgNkxD'
Vue.prototype.$liffId_Service_ConfirmNewCar = '1653760842-Nk0KpkmE'
Vue.prototype.$liffId_Appointment = '1653760842-GrE6LnOm'
Vue.prototype.$liffId_Insurance_Confirm = '1653760842-yoeKGZzR'
Vue.prototype.$liffId_Insurance_QRCode = '1653760842-PMrwD3yA'
Vue.prototype.$liffId_Rating = '1653760842-8xAXG3JB'
Vue.prototype.$liffId_Insurance = '1653760842-kxpYld4g'

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    displayDate (createdAt) {
      const date = new Date(Number(createdAt))
      return ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + String(date.getFullYear()).slice(-2)
    },
    formatDate (createdAt) {
      const date = new Date(Number(createdAt))
      return ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear() + ' ' + ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2)
    },
    formatTime (createdAt) {
      const date = new Date(Number(createdAt))
      return ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2)
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App, QrcodeVue, VueSession, StarRating, DatePicker },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js